import React from 'react';
import clsx from 'clsx';

import { injectedComponent, Text } from '@base/core';

export default injectedComponent(
  {
    name: 'StopReminderDialog',
    styles: ['dialog', 'targetDialog'],
  },
  function StopReminderDialog({
    styles: { dialog: dialogStyles, targetDialog: targetDialogStyles },
  }) {
    return (
      <div className={clsx(targetDialogStyles.dialog)}>
        <p className={dialogStyles.description}>
          <Text>dialog.stop_reminder.description</Text>
        </p>
      </div>
    );
  }
);
